export {default as Home} from "./pages/Home"
export {default as About} from "./pages/About"
export {default as Skills} from "./pages/Skills";
export {default as Portfolio} from "./pages/Portfolio"
export {default as Contact} from "./pages/Contact"